import {createSelector} from 'reselect'
import {getReportsState} from '../selectors'

const selectAuthorizationInfo = createSelector(
    getReportsState,
    (reports) => reports.authorizationInfo
)

export const isAllUsersTimeTrackAvailable = createSelector(
    selectAuthorizationInfo,
    (authorizationInfo) => authorizationInfo.allUsersTimeTrackAvailable
)

export const isOvertimeAvailable = createSelector(
    selectAuthorizationInfo,
    (authorizationInfo) => authorizationInfo.overtimeAvailable
)


// WEBPACK FOOTER //
// ./web/js/reports/authorizationInfo/selectors.js